exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-image[data-v-5e3da094]{position:relative;width:100%;max-width:100%;height:0;mix-blend-mode:multiply}.product-image__placeholder[data-v-5e3da094],.product-image__thumb[data-v-5e3da094]{width:100%;-o-object-fit:contain;object-fit:contain;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%, -50%);transform:translate(-50%, -50%)}.product-image__placeholder[data-v-5e3da094]{max-width:50%;-webkit-filter:grayscale(100%);filter:grayscale(100%)}.product-image--height .product-image__thumb[data-v-5e3da094]{height:100%}.product-image--width .product-image__thumb[data-v-5e3da094]{width:100%;max-height:100%}\n", ""]);

// exports
